import Sidebar from "../Sidebar/sidebar.css"
import { Link } from "react-router-dom";
import { getUserRole } from "../../utils/auth";
// importing images
import dashboard from "../../assets/images/dashboard.png";
import reporting from "../../assets/images/reporting.png";
import logo from "../../assets/images/logo.png";  
// import logoWhite from "../../assets/images/logo-light.png"; 
// import icon from "../../assets/images/logo-icon.png"; 

import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
const SidebarToggle = () => {
  const pubId = localStorage.getItem("account_id");
  const role = getUserRole();
  const [activeIndex, setActiveIndex] = useState(null);
  // const [isOpen, setIsOpen] = useState(false);

  // const toggleSidebar = () => {
  //   setIsOpen(!isOpen);
  // };
  const location = useLocation();
  const menuItems = role === "admin" ? 
  [{ name: "Add Publisher", path: "/add-publisher", image: dashboard },
    { name: "Publisher list", path: "/publisher-list", image: reporting},
    { name: "All Reportings", path: "/admin-reporting", image: reporting}
  ] :
  [
    ...(pubId !== "f3a15f06-c726-4056-a67b-ae96ad22e7e3"
      ? [{ name: "Summary", path: "/summary", image: dashboard }]
      : []),
    { name: "Reporting", path: "/reporting", image: reporting },
    ...(pubId === "789cfdb0-ad79-4bf2-b244-6f883a99379f"
      ? [{ name: "Manage Ad", path: `/manage-ad/${pubId}`, image: dashboard }]
      : [])
  ];
 

  useEffect(() => {
    // Find the active menu item based on current URL
    const currentIndex = menuItems.findIndex((sideBarItems) => sideBarItems.path === location.pathname);
    if (currentIndex !== -1) {
      setActiveIndex(currentIndex);
    }
  }, [location.pathname]);

  // // Hide sidebar on login page
  if (location.pathname === "/") {
    return null;
  }
  if (location.pathname === "/admin") {
    return null;
  }
  return (
          <aside className="sidebar">
            {/* <button type="button" className="sidebar-close-btn">
              <iconify-icon icon="radix-icons:cross-2"></iconify-icon>
            </button> */}
        <div className="sidebar-logo">
          {/* <Link to="" className="sidebar-logo"> */}
            <img src={logo} alt="site logo" className="light-logo" />
            {/* <img src={logoWhite} alt="site logo" className="dark-logo" /> */}
            {/* <img src={icon} alt="site logo" className="logo-icon" /> */}
          {/* </Link> */}
        </div>
        <div className="sidebar-menu-area open">
          <ul className="sidebar-menu show" id="sidebar-menu">
          {
            menuItems.map((sideBarItems, sideBarItemsInd) =>(
                <li key={sideBarItemsInd} className={activeIndex === sideBarItemsInd ? "active" : ""} onClick={()=>setActiveIndex(sideBarItemsInd)}>
                <Link to={sideBarItems.path}>
                  <img src={sideBarItems.image} className="menu-icon" />
                  <span>{sideBarItems.name}</span>
                </Link>
              </li>
            ))
          }  
            {/* <li className="active-page">
                  <Link to="/Reporting" className="active-page">
                  <img src={reporting} className="menu-icon" /> Reporting</Link>
            </li>  */}
          </ul>
        </div>
      </aside>

  );
};

export default SidebarToggle;
